import { callRequest } from '../../helpers/callRequest';
import { autofillParams } from './autofillParams';
import { getBatchQueryKey } from './getQueryKey';
export const getUseWrappedBatchQuery = ({ request, wrapperOptions, getAutofill, getUseQuery, }) => {
    const useQuery = getUseQuery();
    const useWrappedBatchQuery = (parametersArray, queryOptions) => {
        const queryKey = getBatchQueryKey(wrapperOptions, parametersArray);
        const queryFn = () => {
            const promises = parametersArray.map((parameters) => {
                const autofilledParams = autofillParams(parameters, getAutofill);
                return callRequest(request, autofilledParams);
            });
            return Promise.all(promises);
        };
        return useQuery({
            queryKey,
            queryFn,
            ...queryOptions,
        });
    };
    return useWrappedBatchQuery;
};
